import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/8_dark_purple/8_dark_purple"
 * Contains 1 texture(s)
 */
export class Mobile8DarkPurpleAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/8_dark_purple/8_dark_purple';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '8_dark_purple.png'
    ] as const;
}
